import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.wrappers = this.el.querySelectorAll('.moveWrapper')
    this.item = this.el.querySelector('.moveItem')

    this.initEventListeners()
    this.checkPosition()
  }

  initEventListeners() {
    window.addEventListener('scroll', () => {
      this.checkPosition()
    })
  }

  checkPosition() {
    window.scrollY > window.innerHeight
      ? this.wrappers[1].appendChild(this.item)
      : this.wrappers[0].appendChild(this.item)
  }
}
